import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
// import axios from "axios";
import header from "../../config/header.json";

class Header extends Component {
  toggleDropdown = event => {
    event.target.closest(".dropdown").classList.toggle("open");
  };

  toggleWidth = () => {
    const widthClass = document.getElementsByClassName("width-change");
    for (let i = 0; i < widthClass.length; i++) {
      widthClass[i].classList.toggle("active");
    }
  };

  render() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const headerLinks = header["links"]["show"].map((link, linkIndex) => {
      return (
        <li
          key={linkIndex}
          className={
            link.path.includes(this.props.location.pathname) ? "active" : null
          }
        >
          <Link
            to={{
              pathname: link.path[0],
              search: urlSearchParams.toString()
            }}
          >
            {link.name}
          </Link>
        </li>
      );
    });
    return (
      <div className="hdr-wrpr pull-left">
        <div className="logo-wrpr">
          <div className="container">
            <span className="ham" onClick={this.toggleWidth}>
              <svg
                height="32px"
                id="Layer_1"
                version="1.1"
                viewBox="0 0 32 32"
                width="32px"
              >
                <path d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z" />
              </svg>
            </span>
            <div className="logo"></div>
          </div>
        </div>
        <div className="width-change no-width">
          <div className="user-wrpr text-center">
            <div className="container">
              <span className="name center-block">
                {this.props.username || "User@media.net"}
              </span>
            </div>
          </div>
          <div className="container">
            <ul className="links-wrpr semi-bold">{headerLinks}</ul>
            <div className="logout-wrpr">
              <i className="icon icon-ic-log-out" />
              <button className="semi-bold" onClick={this.props.logoutUser}>
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Header);
